import Multiselect from "multiselect-react-dropdown";

const MultiselectInput = ({ field, setFieldValue, values }) => {
  return (
    field.isloading == true ? "" : <Multiselect
                     onSelect={(e)=>{field.onSelect(e,setFieldValue)}}
                     onRemove={(selectedList, removedItem)=>{field.onRemove(selectedList, removedItem,setFieldValue)}}
                        options={field.options}
                        
                        selectedValues={values[field.name]}
                        
                      
                         displayValue="label"
                      />
  );
};

export default MultiselectInput;